import Vue from "vue";

export const store = Vue.observable({
  showPrivacy: false,
  showModal: false,
  showingModal: {},
  loadingCount: 0,
  hasSideNav: false,
  showSideNav: false,
  expandedSideNav: {}
});

export const mutations = {
  showPrivacy: () => {
    store.showPrivacy = true;
  },
  hidePrivacy: () => {
    store.showPrivacy = false;
  },
  showModal: key => {
    store.showModal = true;
    store.showingModal[key] = true;
    store.showingModal = { ...store.showingModal };

    document.body.classList.add("modal-open");
  },
  hideModal: key => {
    store.showingModal[key] = false;
    store.showingModal = { ...store.showingModal };

    let showFlag = false;
    Object.keys(store.showingModal).forEach(k => {
      if (store.showingModal[k]) {
        showFlag = true;
      }
    });

    store.showModal = showFlag;

    if (!showFlag) {
      document.body.classList.remove("modal-open");
    }
  },
  showLoading: () => {
    store.loadingCount += 1;
  },
  hideLoading: () => {
    store.loadingCount -= 1;
    if (store.loadingCount < 0) {
      store.loadingCount = 0;
    }
  },
  toggleSideNav: () => {
    store.showSideNav = !store.showSideNav;
  },
  toggleExpandedSideNav: key => {
    if (!store.expandedSideNav.hasOwnProperty(key)) {
      store.expandedSideNav[key] = true;
    } else {
      store.expandedSideNav[key] = !store.expandedSideNav[key];
    }
    store.expandedSideNav = { ...store.expandedSideNav };
  }
};

export const getters = Vue.observable({
  checkModalShowing: key => {
    return store.showingModal.hasOwnProperty(key) && store.showingModal[key];
  },
  checkLoading: () => {
    return store.loadingCount > 0;
  },
  checkExpandedSideNav: key => {
    return (
      store.expandedSideNav.hasOwnProperty(key) && store.expandedSideNav[key]
    );
  }
});
